"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalContainerService = exports.GlobalEventSharedService = exports.GlobalEventPubSubService = void 0;
const common_1 = require("@slickgrid-universal/common");
const event_pub_sub_1 = require("@slickgrid-universal/event-pub-sub");
const container_service_1 = require("./container.service");
exports.GlobalEventPubSubService = new event_pub_sub_1.EventPubSubService();
exports.GlobalEventSharedService = new common_1.SharedService();
exports.GlobalContainerService = new container_service_1.ContainerService();
//# sourceMappingURL=singletons.js.map